import Menu, { clearSelection, isDesktop } from '@assets/components/menu';
import keyboardAccessibility from '@assets/components/keyboardAccessibility';
import { getHeaderHeight, hideOnBackgroundClick } from '@project/components/utility';

export default class extends Menu {
    constructor() {
        super();
        this.navbarToggler = $('.navbar-toggler');
        this.mainMenu = $('.main-menu');
        this.menuOpener = this.navbarToggler.find('.menu-opener');
        this.menuCloser = this.navbarToggler.find('.menu-closer');
        this.dropDownToggler = $(
            '.dropdown:not(.disabled) [data-toggle="dropdown"]',
        );
    }

    init() {
        const self = this;
        this.headerBannerHandle();
        window.addEventListener('resize', () => {
            getHeaderHeight();
            self.hideMenu();
        });
        hideOnBackgroundClick('menu', this.hideMenu.bind(this));
        $('.navbar-nav').on('click', '.return', function (e) {
            e.preventDefault();
            self.backToPrevMenu(this);
        });
        this.toggleMenu();
        this.keyboardEvents();
        this.dropdownEvents();
        this.mobileMenu();
    }

    toggleMenu() {
        this.navbarToggler.on('click', (e) => {
            e.preventDefault();
            if (this.mainMenu.hasClass('in')) {
                this.hideMenu();
            } else {
                this.showMenu();
            }
        });
    }

    showMenu() {
        this.mainMenu.addClass('in');
        $('.modal-background').addClass('menu').show();
        this.mainMenu.removeClass('d-none');
        this.mainMenu.attr('aria-hidden', 'false');
        this.mainMenu.siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');
        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
        this.menuOpener.addClass('d-none');
        this.menuCloser.removeClass('d-none');
    }

    hideMenu() {
        $('.navbar-nav').find('.top-category:not(.js-prevent-detach)').detach();
        $('.navbar-nav').find('.nav-menu:not(.js-prevent-detach)').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');
        this.mainMenu.siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
        $('.modal-background').hide().removeClass('menu');
        this.menuOpener.removeClass('d-none');
        this.menuCloser.addClass('d-none');
    }

    toggleDropdown(e) {
        if (!isDesktop(this)) {
            e.preventDefault();
            $('.modal-background').show().addClass('menu');
            if (!this.dataset.preventCopy) {
                // copy parent element into back button
                const categoryName = $(this).text();
                const backSpan = $('.close-menu .replace-category');
                backSpan.text(categoryName);
                const closeMenu = $('<li class="nav-menu sticky-div"></li>');
                closeMenu.append($('.close-menu').first().clone());
                $(this)
                    .parent()
                    .children('.dropdown-menu')
                    .prepend(closeMenu)
                    .attr('aria-hidden', 'false');
            }
            // copy navigation menu into view
            $(this).parent().addClass('show');
            $(this).attr('aria-expanded', 'true');
            $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr(
                'aria-hidden',
                'true',
            );
        }
    }

    // this method is different from clearSelection in Menu.js because it doesn't remove the clicked button
    backToPrevMenu(element) {
        $(element)
            .closest('.dropdown')
            .children('.dropdown-menu')
            .children('.top-category')
            .detach();
        $(element)
            .closest('.dropdown.show')
            .children('.nav-link')
            .attr('aria-expanded', 'false');
        $(element)
            .closest('.dropdown.show')
            .children('.dropdown-menu')
            .attr('aria-hidden', 'true');
        $(element).closest('.dropdown.show').removeClass('show');
        $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr(
            'aria-hidden',
            'false',
        );
    }

    headerBannerHandle() {
        const headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
        if (!headerBannerStatus || headerBannerStatus < 0) {
            $('.header-banner').removeClass('d-none');
        }
        $('.header-banner .close').on('click', () => {
            $('.header-banner').addClass('d-none');
            window.sessionStorage.setItem('hide_header_banner', '1');
            getHeaderHeight();
        });
        getHeaderHeight();
    }

    dropdownEvents() {
        this.dropDownToggler.on('click', this.toggleDropdown);
        $(
            '.dropdown:not(.disabled) [data-toggle="dropdown"]:not(#dropdownCountrySelector)',
        )
            .on('mouseenter', function () {
                if (isDesktop(this)) {
                    const eventElement = this;
                    // to close language and search modal if opened
                    document.querySelector('.modal-background').click();
                    $('.navbar-nav > li').each(function () {
                        if (!$.contains(this, eventElement)) {
                            $(this)
                                .find('.show')
                                .each(function () {
                                    clearSelection(this);
                                });
                            if ($(this).hasClass('show')) {
                                $(this).removeClass('show');
                                $(this)
                                    .children('ul.dropdown-menu')
                                    .removeClass('show');
                                $(this)
                                    .children('.nav-link')
                                    .attr('aria-expanded', 'false');
                            }
                        }
                    });
                    // need to close all the dropdowns that are not direct parent of current dropdown
                    $(this).parent().addClass('show');
                    $(this).siblings('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                }
            })
            .parent()
            .on('mouseleave', function () {
                if (isDesktop(this)) {
                    $(this).removeClass('show');
                    $(this).children('.dropdown-menu').removeClass('show');
                    $(this)
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                }
            });
    }

    mobileMenu() {
        $('.navbar>.close-menu>.close-button').on('click', (e) => {
            e.preventDefault();
            $('.menu-toggleable-left').removeClass('in');
            $('.modal-background').hide();

            $('.navbar-toggler').focus();

            $('.main-menu').attr('aria-hidden', 'true');
            $('.main-menu').siblings().attr('aria-hidden', 'false');
            $('header').siblings().attr('aria-hidden', 'false');
        });

        $('.navbar-nav').on('click', '.back', function (e) {
            e.preventDefault();
            clearSelection(this);
        });

        $('.navbar-nav').on('click', '.close-button', (e) => {
            e.preventDefault();
            $('.navbar-nav').find('.top-category').detach();
            $('.navbar-nav').find('.nav-menu').detach();
            $('.navbar-nav').find('.show').removeClass('show');
            $('.menu-toggleable-left').removeClass('in');

            $('.main-menu').siblings().attr('aria-hidden', 'false');
            $('header').siblings().attr('aria-hidden', 'false');

            $('.modal-background').hide();
        });

        $('.navbar-header .user').on('mouseenter focusin', () => {
            if ($('.navbar-header .user .popover').length > 0) {
                $('.navbar-header .user .popover').addClass('show');
                $('.user').attr('aria-expanded', 'true');
            }
        });

        $('.navbar-header .user').on('mouseleave', () => {
            $('.navbar-header .user .popover').removeClass('show');
            $('.user').attr('aria-expanded', 'false');
        });
        $('body').on('click', '#myaccount', (e) => {
            e.preventDefault();
        });
    }

    keyboardEvents() {
        keyboardAccessibility(
            '.main-menu .nav-link, .main-menu .dropdown-link',
            {
                40(menuItem) {
                    // down
                    if (menuItem.hasClass('nav-item')) {
                        // top level
                        $('.navbar-nav .show')
                            .removeClass('show')
                            .children('.dropdown-menu')
                            .removeClass('show');
                        menuItem
                            .addClass('show')
                            .children('.dropdown-menu')
                            .addClass('show');
                        menuItem.find('ul > li > a').first().focus();
                    } else {
                        menuItem
                            .removeClass('show')
                            .children('.dropdown-menu')
                            .removeClass('show');
                        if (menuItem.next().length <= 0) {
                            // if this is the last menuItem
                            menuItem
                                .parent()
                                .parent()
                                .find('li > a') // set focus to the first menuitem
                                .first()
                                .focus();
                        } else {
                            menuItem.next().children().first().focus();
                        }
                    }
                },
                39(menuItem) {
                    // right
                    if (menuItem.hasClass('nav-item')) {
                        // top level
                        menuItem
                            .removeClass('show')
                            .children('.dropdown-menu')
                            .removeClass('show');
                        $(this).attr('aria-expanded', 'false');
                        menuItem.next().children().first().focus();
                    } else if (menuItem.hasClass('dropdown')) {
                        menuItem
                            .addClass('show')
                            .children('.dropdown-menu')
                            .addClass('show');
                        $(this).attr('aria-expanded', 'true');
                        menuItem.find('ul > li > a').first().focus();
                    }
                },
                38(menuItem) {
                    // up
                    if (menuItem.hasClass('nav-item')) {
                        // top level
                        menuItem
                            .removeClass('show')
                            .children('.dropdown-menu')
                            .removeClass('show');
                    } else if (menuItem.prev().length === 0) {
                        // first menuItem
                        menuItem
                            .parent()
                            .parent()
                            .removeClass('show')
                            .children('.nav-link')
                            .attr('aria-expanded', 'false');
                        menuItem
                            .parent()
                            .children()
                            .last()
                            .children() // set the focus to the last menuItem
                            .first()
                            .focus();
                    } else {
                        menuItem.prev().children().first().focus();
                    }
                },
                37(menuItem) {
                    // left
                    if (menuItem.hasClass('nav-item')) {
                        // top level
                        menuItem
                            .removeClass('show')
                            .children('.dropdown-menu')
                            .removeClass('show');
                        $(this).attr('aria-expanded', 'false');
                        menuItem.prev().children().first().focus();
                    } else {
                        menuItem
                            .closest('.show')
                            .removeClass('show')
                            .closest('li.show')
                            .removeClass('show')
                            .children()
                            .first()
                            .focus()
                            .attr('aria-expanded', 'false');
                    }
                },
                27(menuItem) {
                    // escape
                    const parentMenu = menuItem.hasClass('show')
                        ? menuItem
                        : menuItem.closest('li.show');
                    parentMenu.children('.show').removeClass('show');
                    parentMenu
                        .removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    parentMenu.children().first().focus();
                },
            },
            function () {
                return $(this).parent();
            },
        );
        keyboardAccessibility(
            '.navbar-header .user',
            {
                40($popover) {
                    // down
                    if ($popover.children('a').first().is(':focus')) {
                        $popover.next().children().first().focus();
                    } else {
                        $popover.children('a').first().focus();
                    }
                },
                38($popover) {
                    // up
                    if ($popover.children('a').first().is(':focus')) {
                        $(this).focus();
                        $popover.removeClass('show');
                    } else {
                        $popover.children('a').first().focus();
                    }
                },
                27() {
                    // escape
                    $('.navbar-header .user .popover').removeClass('show');
                    $('.user').attr('aria-expanded', 'false');
                },
                9() {
                    // tab
                    $('.navbar-header .user .popover').removeClass('show');
                    $('.user').attr('aria-expanded', 'false');
                },
            },
            () => $('.user .popover li.nav-item'),
        );
    }
}
